/*
token.service.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/services/token.service',[
    'jquery',
    '../module',
    './login.service',
    '../services/activitytracker.service'
], function ($, module) {
    'use strict';

    module.service('tokenService', ['loginService', '$interval', 'activityTrackerService', '$q', function (loginService, $interval, activityTrackerService, $q) {
        var TOKEN_REFRESH_RETRY_DURATION = 5000;

        function getNextAccessToken() {
            if (loginService.isTokenExpired()) {
                loginService.invalidate();
                window.location = '/login';
            } else {
                var refreshDuration = loginService.getTokenRefreshDuration();
                $interval(refreshTokenIfNotAlready, refreshDuration, 1, false);
            }
        }

        function refreshToken() {
            var d = $q.defer();
            if (loginService.isTokenExpired() || !activityTrackerService.validateLastActivityTime()) {
                loginService.invalidate();
                window.location = '/login';
                return $q.reject('Token has expired.');
            }
            var jsonData = {
                cIdToken: loginService.getCIdToken()
            };

            // Async call to server to get new access tokens. On
            // success, sets the new tokens in the localStorage.
            $.ajax({
                contentType: 'application/json',
                type: 'post',
                data: JSON.stringify(jsonData),
                url: '/refreshToken',
                success: function (response) {
                    loginService.setCIdToken(response.cIdToken);
                    getNextAccessToken();
                    d.resolve();
                },
                error: function (error) {
                    if (error.responseText !== 'NON_REFRESHABLE') {
                        $interval(refreshTokenIfNotAlready, TOKEN_REFRESH_RETRY_DURATION, 1, false);
                    } else {
                        getNextAccessToken();
                    }
                    d.reject(error);
                }
            });
            return d.promise;
        }

        function refreshTokenIfNotAlready() {
            loginService.isTokenRefreshed() ? getNextAccessToken() : refreshToken();
        }

        function startRefresh() {
            getNextAccessToken();
        }

        function registerActivity() {
            localStorage.setItem('lastActiveTime', new Date().getTime());
        }

        this.logoutUser = function () {
            loginService.logoutUser();
        };

        this.refreshToken = refreshToken;
        this.startRefresh = startRefresh;
        this.registerActivity = registerActivity;


    }]);

    return module;
});

